import React from "react";
import Banner from "../Banner/Banner";
import classes from "./Banner4.module.scss";
import CustomImage from "../../CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";
import useEmblaOverflow from "../../../hooks/useEmblaOverflow";

const Banner4 = ({ bannerData }: any) => {
  const isMobile = useIsMobile(768);
  const {
    emblaRef: expertEmblaRef,
    canScrollPrev,
    canScrollNext,
    scrollPrev: goToExpertPrev,
    scrollNext: goToExpertNext,
  } = useEmblaOverflow();

  const renderExpertCards = () =>
    bannerData?.expertContact?.map((el: any) => (
      <div className={classes["expert-slide"]} key={el.id}>
        <div className={classes["expert-card"]}>
          <div className={classes["expert-card-content"]}>
            <div className={classes["expert-card-image"]}>
              <CustomImage src={el.image?.url ?? "/icons/expert-image.svg"} height={59} width={59} alt="expert-image" />
            </div>
            <div className={classes["card-details"]}>
              <p className={classes["expert-card-name"]}>{el.name ?? ""}</p>
            </div>
          </div>
          <button
            onClick={() => {
              window.open(el.btnLink ?? "", "_blank");
            }}
            className={`${classes["expert-card-button"]}`}
          >
            {el.btnLabel ?? ""}
          </button>
        </div>
      </div>
    ));

  return (
    <Banner bannerData={bannerData ?? {}} bgInverted={true}>
      <div className={classes["banner-container"]}>
        <h2 className={classes["banner-title"]}>{bannerData?.title ?? ""}</h2>
        <p className={classes["banner-description"]}>{bannerData?.subtitle ?? ""}</p>

        <div className={classes["experts-carousel-wrapper"]}>
          {!isMobile && (
            <button
              className={`${classes["expert-arrow-btn"]}${canScrollPrev ? "" : ` ${classes["expert-arrow-btn-disabled"]}`}`}
              onClick={goToExpertPrev}
              disabled={!canScrollPrev}
              aria-label="Previous expert"
            >
              <CustomImage src="/new-images/left-arrow.svg" height={17} width={10} alt="left-arrow" />
            </button>
          )}
          <div className={classes["expert-viewport"]} ref={expertEmblaRef}>
            <div className={classes["expert-slider-container"]}>{renderExpertCards()}</div>
          </div>
          {!isMobile && (
            <button
              className={`${classes["expert-arrow-btn"]}${canScrollNext ? "" : ` ${classes["expert-arrow-btn-disabled"]}`}`}
              onClick={goToExpertNext}
              disabled={!canScrollNext}
              aria-label="Next expert"
            >
              <CustomImage src="/new-images/right-arrow.svg" height={17} width={10} alt="right-arrow" />
            </button>
          )}
          {isMobile && (
            <div className={classes["expert-arrows-container"]}>
              <button
                className={`${classes["expert-arrow-btn"]}${canScrollPrev ? "" : ` ${classes["expert-arrow-btn-disabled"]}`}`}
                onClick={goToExpertPrev}
                disabled={!canScrollPrev}
                aria-label="Previous expert"
              >
                <CustomImage src="/new-images/left-arrow.svg" height={17} width={10} alt="left-arrow" />
              </button>
              <button
                className={`${classes["expert-arrow-btn"]}${canScrollNext ? "" : ` ${classes["expert-arrow-btn-disabled"]}`}`}
                onClick={goToExpertNext}
                disabled={!canScrollNext}
                aria-label="Next expert"
              >
                <CustomImage src="/new-images/right-arrow.svg" height={17} width={10} alt="right-arrow" />
              </button>
            </div>
          )}
        </div>
      </div>
    </Banner>
  );
};

export default Banner4;
